import React from 'react';
import { useState, useEffect } from 'react';
import './styles/profiles.css'
import Axios from 'axios';
const Profiles = (props) => {

    const [profiles, setProfiles] = useState(props.profiles);
    const [userID, setUserID] = useState(props.userID);
    const [wannaMessage, setWannaMessage] = useState('');
    const [followRequestInProgress, setFollowRequestInProgress] = useState(false);
    const [postMessage, setPostMessage] = useState('');
    const [searchName, setSearchName] = useState('');
    const [backUpProfiles, setBackUpProfiles] = useState(props.profiles);
    const [suffle, setSuffle] = useState(false);


    useEffect(() => {
        // try {
        //     let temp = props.profiles;
        //     for (let i = 0; i < temp.length; i++) {
        //         temp[i]['followed'] = false;
        //         for (let j = 0; j < temp[i].followers.length; j++) {
        //             if (userID === temp[i].followers[j]) {
        //                 temp[i]['followed'] = true;
        //                 console.log('hiii')
        //             }
        //         }
        //     }
        //     setProfiles(temp)
        // } catch{ }
        setBackUpProfiles(props.profiles);
        setProfiles(props.profiles);
    }, [props.profiles]);
    const postMessagetoServer = (_id) => {
        if (postMessage.length > 0) {
            // console.log(_id)
            Axios.post("https://conffesion.herokuapp.com/postMessage", { content: postMessage, _id: _id })
                .then(res => { setWannaMessage(''); setPostMessage(''); })
                .catch(err => { });
        }
    }

    const followRequest = (_id) => {
        if (typeof userID != 'undefined' || userID !== null) {
            setFollowRequestInProgress(true)
            Axios.post("https://conffesion.herokuapp.com/follow", { follower: userID, followed: _id })
                .then(res => {
                    let temp = profiles;
                    for (let i = 0; i < profiles.length; i++) {
                        if (profiles[i]._id == _id) {
                            temp[i]['followed'] = true;
                            temp[i].followers.push(userID);
                        }
                    }
                    setProfiles(temp);

                    setFollowRequestInProgress(false)
                })
                .catch(err => { })
        }
    }
    useEffect(() => {

        let temp = props.profiles;
        for (let i = 0; i < temp.length; i++) {
            temp[i]['followed'] = false;
            for (let j = 0; j < temp[i].followers.length; j++) {
                if (userID === temp[i].followers[j]) {
                    temp[i]['followed'] = true;
                    console.log('hiii')
                }
            }
        }
        setProfiles(temp)
        setTimeout(() => {
            try {
                document.getElementById('postSomethingButton').classList.add('jello')
            } catch{ }
        }, 2000);

    }, []);
    const find = () => {

    }
    useEffect(() => {
        if (searchName.length != 0) {
            let temp = backUpProfiles.filter((s) => {
                return (
                    s.name.toUpperCase().slice(0, searchName.length) === searchName.toUpperCase()
                )
            })
            setProfiles(temp.reverse());
        } else {
            setProfiles(backUpProfiles);
        }
    }, [searchName]);

    useEffect(() => {
        // let temp = profiles.sort(function (a, b) { return 0.5 - Math.random() });
        // setProfiles(temp);
    }, [suffle])



    return (
        <div>
            {/* <span className='suffle' style={{ margin: '0.5rem' }} onClick={() => setSuffle(!suffle)}></span> */}
            <div className='searchBar animated bounce'>
                <div className="form__group field">
                    <input type="input" className="form__field" placeholder="Reply" name="reply" id='name' value={searchName} onChange={(e) => { setSearchName(e.target.value) }} />
                    <label className="form__label">search</label>
                    {/* <button className='btn btn-default' onClick={() => { }}>go</button> */}

                </div>
                {/* <div className='expressBtn d-flex'>
                    <button className='btn btn-outline-secondary p-2 mb-1 '>share a thought</button><span className="thought p-2 animated jello"></span>
                </div> */}

            </div>
            {profiles.map(eachProfile => {
                if (userID !== eachProfile._id && userID !== null) {
                    return (
                        <div className="container card" key={eachProfile._id}>
                            <div className="row profile ">
                                <div className="col-md-3">
                                    <div className="profile-sidebar">

                                        <div className="profile-userpic pp">
                                            <img src={eachProfile.imageString} className="img-responsive immm" alt="" />
                                        </div>
                                        <div className="profile-usertitle">
                                            <div className="profile-usertitle-name">
                                                {eachProfile.name}({eachProfile.followers.length + " followers"})
                                            </div>
                                            <div className="profile-usertitle-job">
                                                {eachProfile.about}
                                            </div>
                                        </div>
                                        <div className="profile-userbuttons">
                                            {eachProfile.followed ? (
                                                <button type="button" className="btn btn-outline-success btn-sm" disabled>Following</button>

                                            ) : (
                                                    <button type="button" className="btn btn-success btn-sm" onClick={() => { followRequest(eachProfile._id) }} disabled={followRequestInProgress}>Follow</button>

                                                )}
                                            {/* <button type="button" className="btn btn-danger btn-sm">Message</button> */}
                                            <button className='btn btn-info btn-sm animated' id='postSomethingButton' onClick={() => { if (wannaMessage.length === 0) setWannaMessage(eachProfile._id); else setWannaMessage('') }}>{wannaMessage !== eachProfile._id ? "Post Something" : "Cancel"}</button>

                                        </div>
                                        <div className="profile-userbuttons">
                                            {wannaMessage === eachProfile._id ? (
                                                <div>
                                                    <textarea rows='3' placeholder='Post anything Anonyomously' value={postMessage} onChange={(e) => { setPostMessage(e.target.value) }}></textarea>
                                                    <button className='btn btn-outline-secondary' onClick={() => { postMessagetoServer(eachProfile._id) }}>Post</button>
                                                </div>
                                            ) : (<p></p>)}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )
                }
            })}
            {
                profiles.length === 0 && searchName.length === 0 ? ('loading...') : ('')
            }
            {
                userID === null ? (<div>Please Signin/Signup(go to Me) or Refresh if you have already done</div>) : (<div></div>)
            }
        </div>
    )
}
export default Profiles;